import PropTypes from 'prop-types';

const ClockIcon = ({ width = '24', height = '24' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2403_61712)">
      <path
        d="M7.5 0.214844C3.36457 0.214844 0 3.57942 0 7.71484C0 11.8503 3.36457 15.2148 7.5 15.2148C11.6354 15.2148 15 11.8503 15 7.71484C15 3.57942 11.6354 0.214844 7.5 0.214844ZM7.5 14.2773C3.88137 14.2773 0.937504 11.3335 0.937504 7.71484C0.937504 4.09622 3.88137 1.15235 7.5 1.15235C11.1186 1.15235 14.0625 4.09622 14.0625 7.71484C14.0625 11.3335 11.1186 14.2773 7.5 14.2773Z"
        fill="#666666"
      />
      <path
        d="M7.96875 3.02734H7.03125V7.90892L9.98108 10.8587L10.6439 10.1959L7.96875 7.52074V3.02734Z"
        fill="#666666"
      />
    </g>
    <defs>
      <clipPath id="clip0_2403_61712">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0 0.214844)"
        />
      </clipPath>
    </defs>
  </svg>
);

ClockIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default ClockIcon;
